module.exports = __webpack_public_path__ + "9beecdb8eabcdbc4c903c7d9d0ce626d.svg";